// @ts-ignore
import React, {PureComponent, CSSProperties} from 'react'
import {inject, observer} from 'mobx-react'
import {Link} from 'react-router-dom'
import cxs from 'cxs/component'
import Store from 'Store'
import Theme, {mediaQueries} from 'Theme'
import {providers, provider} from 'helpers/Providers'
import UserLogout from 'modules/Users/containers/UserLogout'
import {Logo, NavBarDesktop} from 'components'
import {Icon} from 'elements'
import Icomoon from '../elements/Icomoon'
import {lang, langAndRegion} from '../helpers/i18n'
import NavBarMobile from './NavBarMobile'

interface Props {
  store?: Store
}

@inject('store')
@observer
class TitleBar extends PureComponent<Props, object> {
  /*render() {

    console.error('lang',lang)
    console.error('langAndRegion',langAndRegion)

    const {isDesktop} = this.props.store!.UI
    return (
      <Bar>
        {!isDesktop? <NavBarMobile/> : undefined}
        <Link to="/">
          {provider === providers.redsys ? (
            <StyledLogo />
          ) : (
            <StyledIcon name="logo" size={25} />
          )}
        </Link>
        {/!*{isDesktop ? <NavBarDesktop /> : <StyledLogout />}*!/}
        {isDesktop ? <NavBarDesktop /> : <StyledLogout />}
      </Bar>
    )
  }*/

  render() {

    console.error('lang', lang)
    console.error('langAndRegion', langAndRegion)

    const {isDesktop} = this.props.store!.UI

    if (isDesktop)
      return (
        <div style={{
          /*background: 'gray',*/
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
          height: Theme.size.bar,
          padding: `Theme.size.space[1] 0`
        }}>
          <div style={{
            /*background: 'blue',*/
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
          }}>
            <Link
              to="/">
              {provider === providers.redsys ? (
                <StyledLogo/>
              ) : (
                <StyledIcon name="logo" size={25}/>
              )}
              </Link>
          </div>
          <div
            style={{
              /*background: 'salmon',*/
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              alignItems: 'center'
            }}
          >
            <NavBarDesktop/>

          </div>
          {/*{isDesktop ? <NavBarDesktop /> : <StyledLogout />}*/}

        </div>
      )
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
        backgroundColor: Theme.color.background
      }}>
        <NavBarMobile
          style={{
            flex: 1
          }}
        />
        <div style={{
          flex: 5,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
          }}>
            <Link
              to="/">
              {provider === providers.redsys ? (
                <StyledLogo/>
              ) : (
                <StyledIcon name="logo" size={25}/>
              )}
            </Link>
          </div>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
          }}
        >
          <StyledLogout/>
        </div>
        {/*{isDesktop ? <NavBarDesktop /> : <StyledLogout />}*/}

      </div>
    )
  }
}

export default TitleBar

const mobile = {} as CSSProperties

const Bar = cxs('div')({
  display: 'flex',
  height: Theme.size.bar,
  padding: `Theme.size.space[1] 0`,
  textAlign: 'center',
  borderBottom: `${Theme.size.hairline} solid ${Theme.color.hairline}`,
  backgroundColor: Theme.color.background,
  [mediaQueries.desktop]: {
    flexShrink: 0,
    textAlign: 'left'
  }
} as CSSProperties)

const center = {
  position: 'relative',
  top: '50%',
  transform: 'translateY(-50%)'
} as CSSProperties

const StyledIcon = cxs(Icomoon)({
  /*position: 'relative',*/
  /*top: '50%',*/
  /*transform: 'translateY(-50%)',*/
  ':hover': {
    color: Theme.color.primary
  },
} as CSSProperties)

const StyledLogo = cxs(Logo)({
  width: 'auto',
  height: '100%',
  border: '2px solid transparent',
  position: 'relative',
  top: '50%',
  transform: 'translateY(-50%)',
  ':hover': {
    color: Theme.color.primary
  }
} as CSSProperties)

const StyledLogout = cxs(UserLogout)({
  position: 'absolute',
  right: 0,
  top: Theme.common.size.bar / 2 + 'px',
  transform: 'translateY(-50%)'
} as CSSProperties)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TitleBar.tsx